<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title with--button">운전자 관리
          <v-btn v-if="$store.state.userInfo && $store.state.userInfo.writeBus" depressed rounded outlined color="secondary" class="ml-2" @click="setCreateMode">
            <v-icon>add</v-icon> 운전자 추가
          </v-btn>
        </h1>
        <v-container>
          <v-row>
            <nav class="content-left-menu">
              <transition name="fade">
                <div v-if="driverList && driverList.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(driver, idx) in driverList"
                      :key="driver.id"
                      :class="['content-menu__item', {'is--active' : activeIndex === idx}]"
                      @click="setCurrentDriver(driver)"
                    >
                      <strong
                        class="menu__item-main"
                        @click="selectMainItem(idx)"
                      >
                        {{ driver.name }}
                      </strong>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="driverList &&  driverList.length === 0">등록된 운전자가 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-form
                    ref="form"
                    v-if="driver && driver.id || mode === 'CREATE'"
                  >
                    <v-container>
                      <v-row class="pa-2">
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            v-model="driver.name"
                            prepend-icon="person"
                            label="이름"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            prepend-icon="call"
                            v-model="driver.phone"
                            label="연락처"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-checkbox
                            v-model="driver.invisible"
                            label="앱에서 숨기기(비공개)"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col class="text-center mb-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus"
                            :disabled="!(driver.name || '').trim()"
                            color="primary"
                            class="mt-4"
                            rounded
                            @click="onSubmit"
                            large
                            depressed
                          >
                            {{ mode === 'CREATE' ? '등록하기' : '수정하기'}}
                          </v-btn>
                        </v-col>
                     </v-row>
                      <v-row>
                        <v-col class="mt-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus && driver.id"
                            color="error"
                            depressed
                            rounded
                            outlined
                            dark
                            @click="onRemoveDriver">
                            <v-icon>remove</v-icon>
                            운전자제거
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                  <p v-else class="content--empty">선택된 운전자가 없습니다.</p>
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
  </article>
</template>

<script>
import { driver } from '@/api'
import eventBus from '@/utils/eventBus'

export default {
  components: {
  },
  data: () => ({
    item: null,
    driverList: null,
    driver: {
      id: 0,
      name: '',
      phone: '',
      invisible: false
    },
    mode: null,
    valid: true,
    activeIndex: null,
    loading: true
  }),
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      const { data } = await driver.list()
      this.driverList = data
      this.loading = false
    },
    async createDriver () {
      const { data } = await driver.create(this.driver)
      eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
      await this.fetchList()
      this.setCurrentDriver(data)
      this.activeIndex = this.driverList.findIndex(x => x.id === data.id)
    },
    async updateDriver () {
      await driver.set(this.driver.id, this.driver)
      eventBus.$emit('alert', { active: true, text: '수정 되었습니다.' })
      await this.fetchList()
    },
    setCreateMode () {
      this.driver = { invisible: false }
      this.mode = 'CREATE'
      this.activeIndex = null
    },
    setCurrentDriver (driver) {
      this.driver = { ...driver }
      this.mode = 'UPDATE'
    },
    async onSubmit () {
      try {
        eventBus.$emit('showLoading')
        if (this.mode === 'CREATE') {
          await this.createDriver()
        } else {
          await this.updateDriver()
        }
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async onRemoveConfirm () {
      await driver.delete(this.driver.id)
      eventBus.$emit('alert', { active: true, text: '제거되었습니다.' })
      this.setCreateMode()
      await this.fetchList()
    },
    onRemoveDriver () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '운전자를 정말 제거하시겠습니까?',
          okText: '운전자제거',
          confirmHandler: {
            ok: () => {
              this.onRemoveConfirm()
            }
          }
        }
      )
    },
    selectMainItem (index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss">
</style>
